import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import BasketComponent from '../Components/BasketComponent';

const API_URL = '/.netlify/functions';

const Basket = () => {
  const navigate = useNavigate();
  const [basket, setBasket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updating, setUpdating] = useState(false);

  const fetchBasket = useCallback(async () => {
    const basketId = sessionStorage.getItem('basketId');
    if (!basketId) {
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/getBasket?basketId=${basketId}`);
      const data = await response.json();
      setBasket(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBasket();
  }, [fetchBasket]);

  const updateQuantity = async (itemIndex, newQuantity) => {
    setUpdating(true);
    try {
      const basketId = sessionStorage.getItem('basketId');
      const getResponse = await fetch(`${API_URL}/getBasket?basketId=${basketId}`);
      const currentBasket = await getResponse.json();

      const updatedBasket = {
        ...currentBasket,
        basketItems: currentBasket.basketItems.map((item, index) =>
          index === itemIndex ? { ...item, quantity: newQuantity } : item
        )
      };

      const response = await fetch(`${API_URL}/updateBasket?basketId=${basketId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedBasket)
      });

      const data = await response.json();
      setBasket(data);
    } catch (err) {
      console.error('Error updating quantity:', err);
      setError(err.message);
    } finally {
      setUpdating(false);
    }
  };

  const removeItem = async (itemIndex) => {
    setUpdating(true);
    try {
      const basketId = sessionStorage.getItem('basketId');
      const getResponse = await fetch(`${API_URL}/getBasket?basketId=${basketId}`);
      const currentBasket = await getResponse.json();

      const updatedBasket = {
        ...currentBasket,
        basketItems: currentBasket.basketItems.filter((_, index) => index !== itemIndex)
      };

      const updateResponse = await fetch(`${API_URL}/updateBasket?basketId=${basketId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedBasket)
      });

      const data = await updateResponse.json();
      setBasket(data);
    } catch (err) {
      console.error('Error removing item:', err);
      setError(err.message);
    } finally {
      setUpdating(false);
    }
  };

  const onContinueShopping = () => navigate('/shop');

  const onProceedToCheckout = () => {
    const checkoutLink = basket?.links?.find(link => link.type === 'shopCheckout')?.href;
    if (checkoutLink) window.location.href = checkoutLink;
  };

  return (
    <BasketComponent
      basket={basket}
      loading={loading}
      error={error}
      updating={updating}
      updateQuantity={updateQuantity}
      removeItem={removeItem}
      onContinueShopping={onContinueShopping}
      onProceedToCheckout={onProceedToCheckout}
    />
  );
};

export default Basket;